const updateImageDomain = (inputURL: string): string => {
    if(inputURL === "") return inputURL;
    return inputURL?.replace("https://amityonline.com", "https://static.amityonline.com");
  };
  
  export default updateImageDomain;
  